<template>
  <v-layout row wrap>
    <v-flex md2 sm6 xs12 px-2>
      <v-autocomplete
        :value="roleId"
        :items="roleList"
        :label="
          $t('action.actions.select', { field: $tc('models.role') }) + ' (*)'
        "
        :readonly="readonly || !!typeRole"
        @change="onChangeRole"
      />
    </v-flex>
    <template v-if="roleId">
      <v-flex v-if="localTypeRole === 'coordinator'" md4 sm6 xs12 px-2>
        <entity-field
          :value="objectId"
          :_id="entityId"
          :readonly="readonly"
          :label="$tc('models.entity') + ' (*)'"
          @change="$emit('update:objectId', $event)"
        />
      </v-flex>
      <template v-else>
        <v-flex v-if="!readonly" md4 sm6 xs12 px-2>
          <category-menu
            v-model="categoryId"
            clearable
            :label="$tc('models.category')"
          />
        </v-flex>
        <v-flex md4 sm6 xs12 px-2>
          <team-field
            :value="objectId"
            :_id="teamId"
            :category-id="categoryId"
            :entity-id="entityId"
            :readonly="readonly"
            :label="$tc('models.team') + ' (*)'"
            @change="$emit('update:objectId', $event)"
          />
        </v-flex>
      </template>
      <v-flex xs12 px-2>
        <v-checkbox
          v-model="sendInvitationLocal"
          :label="$t('action.buttons.sendInvitationToFbase')"
          color="primary"
          @input="$emit('update:sendInvitation', $event)"
        />
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
export default {
  name: 'BulkCreateInputs',
  components: { EntityField, TeamField, CategoryMenu },
  props: {
    objectId: { type: String },
    roleId: { type: String },
    sendInvitation: { type: Boolean, default: true },
    typeRole: { type: String },
    entityId: { type: String },
    teamId: { type: String },
    readonly: { type: Boolean },
  },
  data() {
    return { categoryId: '' }
  },
  computed: {
    sendInvitationLocal: {
      get() {
        return this.sendInvitation
      },
      set(val) {
        this.$emit('update:sendInvitation', val)
      },
    },
    ...mapGetters({
      roleSelectList: 'roles/selectListFiltered',
    }),
    roleList() {
      return this.roleSelectList.filter((role) =>
        ['coordinator', 'trainer', 'player'].includes(role.type)
      )
    },
    localTypeRole() {
      const role = this.roleList.find((role) => role.value === this.roleId)
      return role.type
    },
  },
  methods: {
    ...mapActions({
      fetchRoles: 'roles/fetchSelectList',
    }),
    onChangeRole(val) {
      this.categoryId = ''
      this.$emit('update:objectId', '')
      this.$emit('update:roleId', val)
    },
  },
  async mounted() {
    await this.fetchRoles()
    if (
      this.typeRole &&
      ['coordinator', 'trainer', 'player'].includes(this.typeRole)
    ) {
      const role = this.roleSelectList.find(
        (role) => role.type == this.typeRole
      )
      this.$emit('update:roleId', role.value)
    }
  },
}
</script>
